import React, { FC, useEffect } from 'react';

import { Grid } from '@mui/material';
import { FormikProps } from 'formik';

import { adminOwnersList, getOwnersList } from '@pharmaplan/common';
import { dropdownMapper } from '@pharmaplan/common/helpers/utils';

import { UNASSIGNED_OWNER_ID } from '../../../../../helpers/Constants';
import { useAppDispatch } from '../../../../../hooks/useAppDispatch';
import { useAppSelector } from '../../../../../hooks/useAppSelector';
import CustomDropdown from '../../../../common/CustomDropdown';
import strings from '../../../../../localization';

import styles from './styles';

interface IOwnershipStatusFilter {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formik: FormikProps<any>;
}

const OwnershipStatusFilter: FC<IOwnershipStatusFilter> = ({ formik }) => {
  const dispatch = useAppDispatch();

  const owners = useAppSelector(adminOwnersList);

  const menuItems = [
    { key: '', label: strings.all },
    { key: UNASSIGNED_OWNER_ID, label: strings.unassigned },
    ...dropdownMapper(owners, 'userId', 'userName'),
  ];

  useEffect(() => {
    dispatch(getOwnersList());
  }, [dispatch]);

  return (
    <Grid xs={6} sx={styles.container}>
      <CustomDropdown
        formik={formik}
        label={strings.ownership}
        name="ownerId"
        id="ownerId"
        menuItems={menuItems}
        customMenuStyles={styles.dropdown}
      />
    </Grid>
  );
};

export default OwnershipStatusFilter;
